export default "__VITE_ASSET__05dfd655__"